export enum ReportDataType {
  BOOLEAN = 'bool',
  INTEGER = 'int',
  STRING = 'str',
  DATETIME = 'datetime',
  CURRENCY = 'currency',
}
